export default __webpack_public_path__ + "static/media/sticker-oe.224314a4.png";